import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { IFBLevel } from '@interfaces';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LevelResource {
  cachedLevels$: Observable<IFBLevel[]>;

  constructor(private http: HttpClient) {}

  getAll() {
    if (!this.cachedLevels$) {
      this.cachedLevels$ = this.http.get<IFBLevel[]>(`https://${environment.API_BASE}/v1/levels`).pipe(shareReplay(1));
    }

    return this.cachedLevels$;
  }
}
